export const CLIENT_ID = "5a3765c1f3c77c25821d0495b336c62f"
export const RESOLVE_URL = "https://soundcloud.com/mouvyourbaudet/sets/mouv-your-baudet"



/** WEBPACK FOOTER **
 ** ./src/constants/player.constants.js
 **/